import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { Masonry } from 'dc/Masonry';
import ActivityCard from 'challenge/common/ActivityCard';
import { useText } from 'common/hooks';
import { ICON } from 'resources/constants';
import {
  HabitsPlaceholderContainer,
  HabitsPlaceholderText,
  HabitLogLoader,
  LogAllButton,
} from './elements';
import { ActivitiesLabel, ActivitiesTitle } from '../elements';

const deps = {
  canLog: state.challenge.log.computedCanLog,
  habits: state.challenge.userChallenge.habits,
  appActivities: state.appContainer.activities,
  activitiesCount:
    state.challenge.stats.daily.user[
      state.challenge.campaign.challenge.startOfDays[
        state.challenge.log.selectedDayIndex
      ]
    ].activitiesCount,
  activityKeysLogging: state.challenge.log.activityKeysLogging,
  toggleLogAllHabits: sequences`challenge.log.toggleLogAllHabitsClicked`,
};

function HabitActivities({
  canLog,
  habits,
  appActivities,
  activitiesCount,
  activityKeysLogging,
  toggleLogAllHabits,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const habitKeys = Object.keys(habits || {});

  const availableHabitKeys = habitKeys.filter(
    activityKey => appActivities[activityKey]
  );

  const loggedHabitActivityKeys = Object.keys(activitiesCount || {}).filter(
    activityKey =>
      availableHabitKeys.includes(activityKey) && activitiesCount[activityKey]
  );

  const activityKeysLoggingArray = Object.keys(activityKeysLogging).filter(
    activityKey => activityKeysLogging[activityKey]
  );

  const isLoggingAnHabit = activityKeysLoggingArray.some(activityKey =>
    availableHabitKeys.includes(activityKey)
  );

  return habitKeys.length > 0 ? (
    <>
      <ActivitiesLabel>
        <ActivitiesTitle icon={ICON.cached} color={'#00AB97'}>
          {`${t('challenge.ChaPaD21A.your_habits')} (${habitKeys.length})`}
        </ActivitiesTitle>
        {isLoggingAnHabit ? (
          <HabitLogLoader icon={ICON.doneAll} />
        ) : (
          <LogAllButton
            checked={
              loggedHabitActivityKeys.length > 0 &&
              loggedHabitActivityKeys.length === availableHabitKeys.length
            }
            disabled={!canLog || availableHabitKeys.length === 0}
            onClick={event => {
              event.stopPropagation();
              toggleLogAllHabits();
            }}
            partiallyChecked={
              loggedHabitActivityKeys.length > 0 &&
              loggedHabitActivityKeys.length !== availableHabitKeys.length
            }
          >
            {t('challenge.ChaPaD21A.ActItem2.Btn33')}
          </LogAllButton>
        )}
      </ActivitiesLabel>
      <Masonry
        cards={habitKeys.map(activityKey => (
          <ActivityCard
            key={activityKey}
            activityKey={activityKey}
            color={'#00AB97'}
            className={'grid-item'}
          />
        ))}
      />
    </>
  ) : (
    <>
      <ActivitiesLabel>
        <ActivitiesTitle icon={ICON.cached} color={'#00AB97'}>
          {`${t('challenge.ChaPaD21A.your_habits')} (${habitKeys.length})`}
        </ActivitiesTitle>
      </ActivitiesLabel>
      <HabitsPlaceholderContainer className={'grid-item'}>
        <HabitsPlaceholderText>
          {t('challenge.ChaPaD21A.press_to_add_habit_activity')}
        </HabitsPlaceholderText>
      </HabitsPlaceholderContainer>
    </>
  );
}

export default connect(deps, HabitActivities);
